import React, { Fragment } from 'react';
import Heading from '@tds/core-heading';
import PropTypes from 'prop-types';

import { formatPrice } from '../../../utils/utils';
import { getLocalizedStrings } from '../../../misc';

const OfficePhone = ({
  officePhone: { lines, totalMonthly, totalOneTime }
}) => {
  const {
    quoteSummary: {
      products: { officePhone: productLabel },
      ratePlan,
      type: typeLabel,
      regularOffer,
      limitedTimeOffer,
      table: { qty, oneTimeCharges, monthlyCharges, total }
    }
  } = getLocalizedStrings();
  const getOfficePhoneTable = () => {
    return (
      lines &&
      lines.map(officePhone => {
        const {
          key,
          type,
          ratePlan: {
            value: ratePlanValue,
            qty: ratePlanQty,
            prices: { monthly: ratePlanMonthly, oneTime: ratePlanOneTime }
          },
          regularOffers,
          limitedTimeOffers
        } = officePhone || {};

        return (
          <Fragment key={key}>
            <tr>
              <td>
                {typeLabel}: {type}
              </td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>
                {ratePlan}: {ratePlanValue}
              </td>
              <td>{ratePlanQty}</td>
              <td>{formatPrice(ratePlanOneTime)}</td>
              <td>{formatPrice(ratePlanMonthly)}</td>
            </tr>
            {regularOffers &&
              regularOffers.length > 0 &&
              regularOffers.map(
                ({
                  key: roKey,
                  value: roValue,
                  qty: roQty,
                  prices: { oneTime: roOneTime, monthly: roMonthly } = {}
                }) => (
                  <tr key={`officePhoneRegularOffer${roKey}`}>
                    <td>
                      {regularOffer}: {roValue}
                    </td>
                    <td>{roQty}</td>
                    <td>{formatPrice(roOneTime)}</td>
                    <td>{formatPrice(roMonthly)}</td>
                  </tr>
                )
              )}
            {limitedTimeOffers &&
              limitedTimeOffers.length > 0 &&
              limitedTimeOffers.map(
                ({
                  key: ltoKey,
                  value: ltoValue,
                  qty: ltoQty,
                  prices: { oneTime: ltoOneTime, monthly: ltoMonthly } = {}
                }) => (
                  <tr key={`officePhoneLimitedOffer${ltoKey}`}>
                    <td>
                      {limitedTimeOffer}: {ltoValue}
                    </td>
                    <td>{ltoQty}</td>
                    <td>{formatPrice(ltoOneTime)}</td>
                    <td>{formatPrice(ltoMonthly)}</td>
                  </tr>
                )
              )}
            <tr>
              <td colSpan="4" style={{ height: '49px' }}></td>
            </tr>
          </Fragment>
        );
      })
    );
  };

  return (
    <>
      <div style={{ overflowX: 'auto' }}>
        <Heading level="h3">{productLabel}</Heading>
        <br />
        <table>
          <thead>
            <tr>
              <th width="60%"></th>
              <th>{qty}</th>
              <th>{oneTimeCharges}</th>
              <th>{monthlyCharges}</th>
            </tr>
          </thead>
          <tbody>
            {getOfficePhoneTable()}
            <tr>
              <td>{total}</td>
              <td></td>
              <td>{formatPrice(totalOneTime)}</td>
              <td>{formatPrice(totalMonthly)}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
};

OfficePhone.defaultProps = {
  officePhone: {}
};

OfficePhone.propTypes = {
  officePhone: PropTypes.objectOf(PropTypes.any)
};

export default OfficePhone;
